<template>
  <modal
    :show="showNewModal"
    size="lg"
    modal-classes="modal-secondary"
    @close="$emit('modal-product-editar-dismiss')"
  >
    <h5 slot="header" class="modal-title">Criar produto</h5>
    <iframe
      id="modalProductNovoIframe"
      src="/products/add?&layout=iframe&iframed=true"
      frameborder="0"
      scrolling="no"
      width="100%"
      height="711"
      @onload="onLoadIframe"
    ></iframe>
    <template slot="footer">
      <b-button
        type="button"
        variant="link"
        class="ml-auto"
        @click="$emit('modal-product-novo-dismiss')"
        >Fechar</b-button
      >
      <b-button
        type="button"
        variant="primary"
        class="new-event--add"
        @click="salvarProduto"
        >Salvar</b-button
      >
    </template>
  </modal>
</template>
<script>
var $ = require("jquery");
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import Modal from "@/components/Modal";

export default {
  name: "modal-product-novo",
  components: {
    Modal,
  },
  props: {
    showNewModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    salvarProduto() {
      var iframeSelector = "modalProductNovoIframe";
      var pm_data = {
        selector: "#ProductAddForm",
        action: "submit",
        event_name: "",
      };
      try {
        window.document
          .getElementById(iframeSelector)
          .contentWindow.postMessage(pm_data, "*");
      } catch (e) {
        console.error(
          "erro ao executar envio de mensagem para " + iframeSelector
        );
      }
    },
    listenToIframe(event) {
      //INSERIR ESSE CÓDIGO NO COMPONENTE DE VUE.JS PARA "ESCUTAR" O IFRAME
      if (
        true ||
        event.origin.endsWith("bocapio.com.br") ||
        event.origin.endsWith("bocapio.com")
      ) {
        const data = JSON.parse(event.data);
        const flash = JSON.parse(data.flash);
        this.$emit("modal-product-novo-action", data.Product);
        swal.fire({
          title: (flash.params.class = "success" ? "Sucesso" : "Erro"),
          text: flash.message,
          buttonsStyling: false,
          confirmButtonClass: (flash.params.class = "success"
            ? "btn btn-success"
            : "btn btn-warning"),
          icon: (flash.params.class = "success" ? "success" : "warning"),
        });
      } else {
        console.error("CORS policy execution failed");
      }
    },
    onLoadIframe() {
      $(".modal-secondary .modal-content").css("background", "#FFF");
    },
  },
  watch: {
    showNewModal(val) {
      if (val) {
        window.addEventListener("message", this.listenToIframe, true);
      } else {
        window.removeEventListener("message", this.listenToIframe, true);
      }
    },
  },
};
</script>
<style>
</style>